import Vue from "vue";
import 'vant/lib/icon/local.css';
import {
  Col,
  Cell,
  Row,
  Tag,
  Tab,
  Tabs,
  Icon,
  Area,
  Radio,
  Field,
  Popup,
  Button,
  Picker,
  Sticky,
  Divider,
  NavBar,
  Switch,
  Toast,
  Stepper,
  Collapse,
  Progress,
  CellGroup,
  RadioGroup,
  ActionSheet,
  CollapseItem,
  DatetimePicker,
  Search,
  Overlay,
  Dialog
} from "vant";

Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Area);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Toast);
Vue.use(NavBar);
Vue.use(Sticky);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Picker);
Vue.use(Progress);
Vue.use(Stepper);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(CellGroup);
Vue.use(RadioGroup);
Vue.use(ActionSheet);
Vue.use(CollapseItem);
Vue.use(DatetimePicker);
Vue.use(Search);
Vue.use(Overlay);
Vue.use(Dialog);
